import React from 'react';
import {Route, Routes} from 'react-router-dom';

// 页面组件
import Home from "../pages/Home";
import WebHosting from "../pages/WebHosting";
import WebHostingAiPreview from "../pages/WebHostingAiPreview";
import WebHostingEditor from "../pages/WebHostingEditor";
import MonitorPage from "../pages/Monitor";
import About from "../pages/About";
import Demo from "../pages/Demo";
import Directories from "../pages/Directories";
import Galleries from "../pages/Galleries";
import ImageProcessing from "../pages/ImageProcessing";
import ImageWatermark from "../pages/ImageWatermark";
import FormatConvert from "../pages/FormatConvert";
import ImageCompress from "../pages/ImageCompress";
import VideoToGif from "../pages/VideoToGif";
import VideoCompressor from "../pages/VideoCompressor";
import AIGenerate from "../pages/AIGenerate";
import ImageSearch from "../pages/ImageSearch";
import Trash from "../pages/Trash";
import Invite from "../pages/Invite";
import InviteWelcome from "../pages/InviteWelcome";
import EncryptedLinks from "../pages/EncryptedLinks";
import DirectoryShare from "../pages/DirectoryShare";
import NotFound from "../pages/NotFound";
import ToolVisitTracker from "./ToolVisitTracker";

const AppRoutes: React.FC = () => {
  return (
    <>
      <ToolVisitTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/img-cloud/index.html" element={<Home />} />
        <Route path="/web-hosting" element={<WebHosting />} />
        <Route path="/web-hosting/ai-preview" element={<WebHostingAiPreview />} />
        <Route path="/web-hosting/editor/:id" element={<WebHostingEditor />} />
        <Route path="/galleries" element={<Galleries />} />
        <Route path="/directories" element={<Directories />} />
        <Route path="/monitor" element={<MonitorPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/image-processing" element={<ImageProcessing />} />
        <Route path="/image-watermark" element={<ImageWatermark />} />
        <Route path="/format-convert" element={<FormatConvert />} />
        <Route path="/image-compress" element={<ImageCompress />} />
        <Route path="/video-to-gif" element={<VideoToGif />} />
        <Route path="/video-compressor" element={<VideoCompressor />} />
        <Route path="/ai-generate" element={<AIGenerate />} />
        <Route path="/image-search" element={<ImageSearch />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="/invite-welcome" element={<InviteWelcome />} />
        <Route path="/encrypted-links" element={<EncryptedLinks />} />
        <Route path="/share/d" element={<DirectoryShare />} />
        <Route path="/share/d/:shareCode" element={<DirectoryShare />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
